import { BodyText } from '@unmind/design-system';
import { rem } from 'polished';
import styled from 'styled-components';

export const RoomContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${rem(40)};
`;

export const LoadingContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
`;

export const LoaderContainer = styled.div`
  margin-top: auto;
  margin-bottom: auto;
`;

export const SpeakerLabel = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize20],
  weight: theme.typography.fontWeights.semiBold,
}))`
  text-align: center;
  margin-top: 32px;
  margin-bottom: 40px;
`;
